import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const GUARANTEES = ['Acceso inmediato', 'Pago único', 'Garantía de 7 días'];
export function FinalCta() {
  return <section className="w-full bg-navy-950 py-12 sm:py-16" aria-labelledby="final-title" data-id="element-51" data-mp="15dlvf1xpx2uq">
      <div className="mx-auto w-full max-w-xl px-4" data-id="element-52" data-mp="1jd50tmz5a03c">
        <h2 id="final-title" className="text-center font-display text-[27px] font-bold leading-tight text-white sm:text-4xl" data-id="element-53" data-mp="1jbk7u1shap7l">
          Una decisión puede cambiar la forma en que atenderá a sus pacientes
        </h2>

        <div className="mt-6 space-y-3" data-id="element-54" data-mp="1o3vahcelsp3u">
          <p className="rounded-2xl border border-white/10 bg-white/5 p-4 text-[14px] leading-relaxed text-cream-100/80 sm:text-[15px]" data-id="element-55" data-mp="1o56ad14xhcpo">
            Puede seguir dependiendo de múltiples guías, artículos y búsquedas antes de cada
            decisión clínica.
          </p>
          <p className="rounded-2xl border-2 border-gold-500 bg-gold-500/10 p-4 text-[14px] font-semibold leading-relaxed text-white sm:text-[15px]" data-id="element-56" data-mp="n648rgkhhei8">
            O puede contar con un sistema que concentre todo ese conocimiento en una
            metodología práctica, organizada y lista para aplicar.
          </p>
        </div>

        <p className="mt-6 text-center font-display text-[20px] font-bold leading-snug text-gold-400 sm:text-2xl" data-id="element-57" data-mp="123mx4ht91pp5">
          La diferencia no está en trabajar más. Está en tener un mejor sistema.
        </p>

        <p className="mt-4 text-center text-[14.5px] leading-relaxed text-cream-100/80 sm:text-base" data-id="element-58" data-mp="1b1yxhbjx41us">
          Comience hoy mismo y prescriba Terapia de Reemplazo con Testosterona con mayor
          seguridad desde su próxima consulta.
        </p>

        <div className="mt-7 rounded-3xl bg-white/[0.06] p-4 sm:p-6" data-id="element-59" data-mp="1psple8ie2gsm">
          <p className="text-center text-[12px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-60" data-mp="1pqmod4itjnee">
            Acceda hoy por solo
          </p>
          <p className="mt-1 text-center font-display text-[48px] font-bold leading-none text-white sm:text-6xl" data-id="element-61" data-mp="3qvqjxw9ht4mf">
            USD 12.99
          </p>
          <p className="mt-2 text-center text-[12px] font-medium text-cream-100/65" data-id="element-62" data-mp="3ltremgu6zxmu">
            Cambio de moneda automático según su país
          </p>

          <div className="mt-5 flex flex-col items-center gap-5" data-id="element-63" data-mp="3uv7o8md6nvq0">
            <ScarcityBar data-id="element-64" data-mp="dfiulx5qkf6a" />
            <CtaButton label="Quiero el Sistema Maestro de TRT" data-id="element-65" data-mp="depvnid0qtyp" />
            <Countdown label="Su precio promocional expira en" data-id="element-66" data-mp="8go9upo7kgjj" />
          </div>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-67" data-mp="8j25azmsvurm">
            {GUARANTEES.map(item => <li key={item} className="flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-[0.08em] text-cream-100/80" data-id="element-68" data-mp="iecafw8hwi9m">
                <CheckIcon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-69" data-mp="2k6iasq3z1t8i" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}